import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification } from "antd";
import moment from "moment";
import numeral from "numeral";
import React, { useLayoutEffect,  useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { openNotificationWithIcon, isNumeric } from "../../../libs/utils";
import { getWorkspaceSettlement, openVatSettlement } from "../../../store/actions/reports/vatSettlement";

const MonthSlickSlider = ({businessId, setCurrentSettlmentInfo, selectedMonth, setSelectedMonth, selectedYear}) => {
  const intl = useIntl();
  const carouselRef=useRef();  
  const dispatch = useDispatch();
  // const paramentersStore = useSelector(state => state.reports.vat?.parameters);
  const settlementsReport = useSelector(state => state.reports.vat);
  const settlementsList = settlementsReport?.settlements?.settlementApiResList;  
  const currentYear = new Date().getFullYear();  
  // const currentMonth = new Date().getMonth();  

  const openPeriod = (
    businessId, year, ordinal
  ) => {

    dispatch(openVatSettlement(
      businessId, year, ordinal
    ))
      .then(res => { 
        dispatch(getWorkspaceSettlement(selectedYear));
      })
      .catch(err => {
        openNotificationWithIcon(
          notification,
          "error",
          "",
          "Si è verificato un errore",
          null,
          null
        );
      });
  };
  
  const MonthCard = ({elem, enableReopen, enableConsolidate}) => {  
  
    const monthValue = isNumeric(elem.month) ?  moment(elem.month, "M").locale("it").format("MMMM") : intl.formatMessage({ id: `reports.vat.${elem.month}`});    
    const isFuture = false;
    // TODO capire come gestire  const isFuture =  elem.month > currentMonth + 1 && currentYear === parseInt(paramentersStore.refYear);

    useLayoutEffect(() => {    
      /** se lasciato nel componente padre non sempre riesce a renderizzare e scrollare */             
      if (parseInt(selectedYear) !== currentYear){ 
        return; 
      }
      if (carouselRef && carouselRef.current) {     
        let slideNumber = isNumeric(selectedMonth) ? selectedMonth : settlementsList.findIndex(el => el.month === selectedMonth);
        carouselRef.current.goToSlide(slideNumber);
      }
    }, [/* carouselRef, currentMonth, selectedYear*/]);

    const selectedMonthIndex = settlementsList.findIndex(el => el.month === elem.month);
    
    const enableConsolida = !!(!settlementsList[selectedMonthIndex]?.closed && ((elem.month.toString() === "1" || elem.month === "FIRST_QUARTER") || (selectedMonthIndex === settlementsList.length - 1 && !settlementsList[selectedMonthIndex]?.closed) || (settlementsList[selectedMonthIndex - 1]?.closed && !settlementsList[selectedMonthIndex + 1]?.closed)));    

    return (
      <div onClick={()=>{        
        // setto una serie di info per il mese corrente e il settlemnt corrispondente
        localStorage.setItem("report_vat_month", isNumeric(elem.month) ? elem.month - 1 : elem.month);        
        setCurrentSettlmentInfo({ state: { year: selectedYear, month: isNumeric(elem.month) ? elem.month - 1 : elem.month, enableConsolidate: enableConsolidate, settlement: elem } });
        setSelectedMonth(isNumeric(elem.month) ? elem.month - 1 : elem.month);
      }
    
      }
      className={`shadowMonthCard ${isFuture ? "isFuture" : ""} ${!enableReopen && elem.closed ? "disabled" : ""} ${!enableConsolida && !elem.closed ? "disabled" : ""}`} >
        <div className={isNumeric(elem.month) ? elem.month -1 === selectedMonth ? "active" : "" : elem.month === selectedMonth ? "active" : ""}>
          <div>
            <div className="monthTitle">
              {monthValue.charAt(0).toUpperCase() + monthValue.slice(1).toLocaleLowerCase()}
            </div>
            <div className="monthContent">
              
              <FormattedMessage id={`reports.vat.${elem.currentPeriodCredit ? "vatOnCredit" : "vatOnDebit"}`}/>
              
              <div className="monthAmount">
                {
                  `${numeral(Math.abs(elem.currentPeriodCredit || elem.currentPeriodDebt || 0)).format("0,0.00")} €`
                }
              </div>
            </div>
          </div>
          <div>{
            (!isFuture || elem.settlementId && totalCreditAndDebit !== 0) && 
            (              
              <div onClick={(e)=> {
                // e.stopPropagation(); 
                if (elem.closed && enableReopen){                  
                  openPeriod(
                    businessId, selectedYear, isNumeric(elem.month) ?  (moment(elem.month, "M").locale("en").format("MMMM")).toUpperCase() : intl.formatMessage({ id: `reports.vat.${elem.month}`})
                  ); 
                }
              }} className={`settlementLock ${elem.closed && !enableReopen? "closed" : "" }`} 
              style={{cursor: elem.closed && enableReopen ? "pointer" : "auto" }}>
                <FontAwesomeIcon style={{padding: "0 8px 0 8px"}} icon={["far", elem.closed ? "lock" : "lock-open"]} />                 
                {elem.closed && <FormattedMessage id="reports.vat.reopenPeriod"/>}                
              </div>                
            )
          }</div>
        </div>
      </div>
    );
  };

  const CustomLeftArrow = ({ onClick }) => {
    return (
      <button onClick={onClick} aria-label="Go to previous slide" className="month-carousel__arrow--left" type="button">
        <FontAwesomeIcon icon={["far", "angle-left"]} />
      </button>
      
    );
  };
  const CustomRightArrow = ({ onClick }) => {    
    return (
      <button onClick={(e) => {        
        onClick();
      }} aria-label="Go to previous slide" className="month-carousel__arrow--right" type="button">
        <FontAwesomeIcon icon={["far", "angle-right"]} />
      </button>
    );
  };

  /** Faccio in modo da far riaprire solo un periodo con businessSettlements altrimenti si resta bloccati
   * nell'impossibilità di consolidare.   
  let filteredWithData=[];
  if (settlementsList){
    filteredWithData = settlementsList.filter(current => current.businessSettlements.length > 0);        
  }
*/

  return settlementsReport.status.started  ? 
    <div style={{margin: "35px -18px",
      height: "235px",
      display: "flex",
      color: "#0090d1",
      alignItems: "center",
      justifyContent: "center",
      width: "calc(100% + 35px)",
      position: "relative"}}
    >
      <FontAwesomeIcon icon={["far", "circle-notch"]} style={{ fontSize: "34px" }} spin />
    </div> 
    :    
    (
      <div style={{margin: "35px -18px",
        height: "235px",
        width: "calc(100% + 35px)",
        position: "relative"}}
      >
        <Carousel
          focusOnSelect={true} 
          ref={carouselRef}
          additionalTransfrom={0}
          arrows
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
          autoPlaySpeed={3000}        
          className=""
          containerClass="container"
          dotListClass=""
          draggable          
          infinite={false}
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={{
            screen12: {
              breakpoint: {              
                max: 10000,
                min: 2727
              },
              items: 12
            },
            screen11: {
              breakpoint: {              
                max: 2727,
                min: 2522
              },
              items: 11
            },
            screen10: {
              breakpoint: {              
                max: 2522,
                min: 2317
              },
              items: 10
            },
            screen9: {
              breakpoint: {              
                max: 2317,
                min: 2112
              },
              items: 9
            },
            screen8: {
              breakpoint: {              
                max: 2112,
                min: 1907
              },
              items: 8
            },              
            screen7: {
              breakpoint: {              
                max: 1907,
                min: 1702
              },
              items: 7
            },
            screen6: {
              breakpoint: {              
                max: 1702,
                min: 1497
              },
              items: 6
            },
            screen5: {
              breakpoint: {              
                max: 1497,
                min: 1292
              },
              items: 5
            },
            screen4: {
              breakpoint: {              
                max: 1292,
                min: 1087
              },
              items: 4
            },
            screen3: {
              breakpoint: {              
                max: 1087,
                min: 882
              },
              items: 3
            },

            screen2: {
              breakpoint: {              
                max: 882,
                min: 677
              },
              items: 2
            },
            screen1: {
              breakpoint: {              
                max: 677,
                min: 0
              },
              items: 1
            }
          }}
          rewind={false}
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
          partialVisible={false}          
          centerMode={false} 
        >
          {
            settlementsList ? settlementsList.map((el, index) => {   
              // const currentIndexInFilter = filteredWithData.findIndex(c => c.month === el.month);                            
              return <MonthCard key={index} elem={el} 
                enableConsolidate={!!(!settlementsList[index]?.closed && ((index === 0) || (index === settlementsList.length - 1 && settlementsList[index-1]?.closed) || (settlementsList[index-1]?.closed && !settlementsList[index+1]?.closed)))}        
                enableReopen={!!(settlementsList[index]?.closed && ((index === 0 && !settlementsList[index+1]?.closed)) || (index === settlementsList.length - 1) || (settlementsList[index-1]?.closed && !settlementsList[index+1]?.closed))}
              
                /* enableConsolidate={!!(!filteredWithData[currentIndexInFilter]?.closed && ((currentIndexInFilter === 0) || (currentIndexInFilter === filteredWithData.length - 1 && filteredWithData[currentIndexInFilter-1]?.closed) || (filteredWithData[currentIndexInFilter-1]?.closed && !filteredWithData[currentIndexInFilter+1]?.closed)))}        
                enableReopen={!!(filteredWithData[currentIndexInFilter]?.closed && ((currentIndexInFilter === 0 && !filteredWithData[currentIndexInFilter+1]?.closed)) || (currentIndexInFilter === filteredWithData.length - 1) || (filteredWithData[currentIndexInFilter-1]?.closed && !filteredWithData[currentIndexInFilter+1]?.closed))}  */
              />;
            }) : []
          }
          
        </Carousel>
      
      </div>
    );
};

export default MonthSlickSlider;
